export default from './post-content';



// WEBPACK FOOTER //
// ./app/components/post-content/index.js